import styled from 'styled-components';

export const InvisibleText = styled('span')`
  visibility: hidden;
`;
